import React from "react";
import { graphql } from "gatsby";

import SlideWithReviewCard from "../modules/SlideWithReviewCard";

export default function CarouselWithReviewSlider({ data }) {
  const { carouselContent } = data;

  const trimmedCarouselContent = carouselContent.filter(
    (page) => page.internal
  );

  const getComponentFromBlockType = (blockType) => {
    const components = {
      SlideWithReviewCard,
    };

    const componentToRender = components[blockType.split("DatoCms")[1]];
    return componentToRender;
  };

  const renderCarouselContent = (pageContent, customClass) => {
    return pageContent.map((item, index) => {
      const key = index;
      const blockType = item.internal.type;
      const Component = getComponentFromBlockType(blockType);
      let settings = { key, customClass, data: item, blockType };
      if (!Component) {
        return <></>;
      }

      return <Component {...settings} />;
    });
  };

  return <div>{renderCarouselContent(trimmedCarouselContent, "")}</div>;
}

export const carouselQuery = graphql`
  fragment CarouselWithReviewCardSlider on DatoCmsCarouselWithReviewCardSlider {
    internal {
      type
    }
    carouselContent {
      ... on DatoCmsSlideWithReviewCard {
        internal {
          type
        }
        shopifyProductData {
          metafields {
            key
            namespace
            value
          }
        }
      }
    }
  }
`;
